import { render } from "./artistComponent.vue?vue&type=template&id=15f0cfd9&scoped=true"
import script from "./artistComponent.vue?vue&type=script&lang=js"
export * from "./artistComponent.vue?vue&type=script&lang=js"

import "./artistComponent.vue?vue&type=style&index=0&id=15f0cfd9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15f0cfd9"]])

export default __exports__